export default __webpack_public_path__ + "static/media/menuL_icon_04.869679e6.png";